import { createContext } from 'react';

import { ContentSwitcherValue } from '../../types';

export const ContentContext = createContext<{
  activeItems: Record<string, string>;
  defaultItems: Record<string, string>;
  displayedValues: ContentSwitcherValue[];
  setValues: (values: ContentSwitcherValue[]) => void;
  handleSettingsClick: (
    value: string | string[],
    anchor?: boolean,
  ) => () => void;
}>({
  activeItems: {},
  defaultItems: {},
  displayedValues: [],
  setValues: () => null,
  handleSettingsClick: () => () => null,
});
